export const CANCELLATION_WINDOW_CASH_DAYS = 120
